(function($) {

  var DeliveryDateManager = function() {
		
    this.local = $("#localDeliveryContainer");
    this.national = $("#nationalDeliveryContainer");

    this.registerEventListener = function() {
	  var _this = this;
	  var deliverySelect = $("select.clickCollectLocation").first();
	  deliverySelect.on( "change", function() {
	    var optionText = deliverySelect.find("option:selected").text();
		if (/local/i.test(optionText)) {
		  _this.showOnlyLocal();
		} else if (/national/i.test(optionText)) {
		  _this.showOnlyNational();
		} else {
		  _this.hideNationalAndLocal();
		}
	  });
	};

    this.showOnlyLocal= function() {
	  this.local.show();
	  this.national.hide();
	};

    this.showOnlyNational = function() {
	  this.local.hide();
	  this.national.show();
	};

    this.hideNationalAndLocal = function() {
	  this.local.hide();
	  this.national.hide();
	};

    this.start = function() {
	  this.hideNationalAndLocal();
	  this.registerEventListener();
	}
  }

  var manager = new DeliveryDateManager();
  manager.start();

})(jQuery)